import * as React from 'react';
import { CognitoUser } from '../../app/Login/lib/CognitoUser';

interface IChangePasswordProps {
  confirmation: number
}

interface IChangePasswordState {
  password: string
  confirmPassword: string
  notification: string
  showMismatchedPasswords: boolean
  showNotificationMessage: boolean
  confirmation: number
  username: string
}

export class ChangePasswordContainer extends React.Component<IChangePasswordProps, IChangePasswordState> {
  state: IChangePasswordState = {
    password: '',
    confirmPassword: '',
    notification: '',
    showMismatchedPasswords: false,
    showNotificationMessage: false,
    confirmation: 0,
    username: ''
  }

  updatePassword(password) {
    this.setState({ password })
  }

  updateConfirmPassword(confirmPassword) {
    this.setState({ confirmPassword })
  }

  updateConfirmation(confirmation) {
    this.setState({ confirmation })
  }

  updateUsername(username) {
    this.setState({ username })
  }

  async changePassword(e) {
    e.preventDefault()

    const { password, confirmPassword, username, confirmation } = this.state

    if (password !== confirmPassword) {
      this.setState({ showMismatchedPasswords: true })
      return
    } else {
      this.setState({ showMismatchedPasswords: false })
    }

    try {
      const cognitoUser = new CognitoUser(username)

      await cognitoUser.updatePassword(confirmation, password, username)

      //NOTE: Display success message. Then redirect to login page.
      const showNotificationMessage = true
      const notification = 'Password updated successfully. You will be redirected to the login page shortly.'
      this.setState({ showNotificationMessage, notification })
      // tslint:disable-next-line:only-arrow-functions
      setTimeout(() => {
        window.location.href = '/login'
      }, 3000)
    } catch (err) {
      console.log(err)
      const showNotificationMessage = true
      const notification = err.message
      this.setState({ showNotificationMessage, notification })
    }
  }

  render() {
    const { password, confirmPassword, notification, showMismatchedPasswords, showNotificationMessage, confirmation, username } = this.state

    let confirm = null
    if (!confirmation) {
      confirm = this.props.confirmation
    }

    confirm = (!confirmation) ? this.props.confirmation : confirmation

    return (
      <div>
        <div className="row rowNoMarginTop">
          <div className="col s12 m4 l3 blue darken-3" style={{ backgroundColor: '#000', height: '1px' }}>
          </div>
          <div className="col s12 m8 l9 white">
            <h3>Change Password</h3>
            <form onSubmit={(e) => this.changePassword(e)}>
              <div className="row">
                <div className="col s12 m6">
                  <div className="row">
                    <div className="col s12">
                      <div className="input-field">
                        <input name="frmuser" id="username" type="text" className="validate" value={username} onChange={(e) => this.updateUsername(e.currentTarget.value)} />
                        <label className="active" htmlFor="username">Username</label>
                      </div>
                      <div className="input-field">
                        <input name="frmuser" id="confirmation" type="text" className="validate" value={confirm} onChange={(e) => this.updateConfirmation(e.currentTarget.value)} />
                        <label className="active" htmlFor="confirmation">Confirmation Code</label>
                      </div>
                      <div className="input-field">
                        <input name="frmuser" id="password" type="password" className="validate" value={password} onChange={(e) => this.updatePassword(e.currentTarget.value)} />
                        <label className="active" htmlFor="password">New Password</label>
                      </div>
                      <div className="input-field">
                        <input value={confirmPassword} name="frmpswd" id="confirm_password" type="password" className="validate" onChange={(e) => this.updateConfirmPassword(e.currentTarget.value)} />
                        <label className="active" htmlFor="confirm_password">Confirm Password</label>
                      </div>
                      <button className="btn btn-primary" type="submit" value="Submit">Submit</button>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6">
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row rowNoMarginTop">
          <div className="col s12 m4 l3 blue darken-3" style={{ backgroundColor: '#000', height: '1px' }}>
          </div>
          <div className="col s12 m8 l9 white">
            <div style={{ padding: '10px 0 0 10px', height: '80px' }}>
              {showMismatchedPasswords
                ?
                <div className="error">
                  The passwords you have entered do not match.
                </div>
                : null}
              {showNotificationMessage ?
                <div className="notificationMessage">
                  {notification}
                </div>
                : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
